export const rows = [
    { "key": "grade", "value": "学年" },
    { "key": "department", "value": "学科" },
    { "key": "semester", "value": "開設時期" },
    { "key": "subject_name", "value": "科目名" },
    { "key": "category", "value": "科目区分" },
    { "key": "credit_type", "value": "単位種別" },
    { "key": "credits", "value": "単位数" },
    { "key": "instructors", "value": "担当教員" },
    { "key": "class_format", "value": "形態" },
    { "key": "classification", "value": "区分" }
];